/*
 * Copyright (c) 2023 Helvia Technologies PC <contact@helvia.io>
 */
import { useTranslation } from "react-i18next";
import parse from "html-react-parser";
// components imports
import { Typography } from "antd";

// misc
import { IRequestError } from "@/interfaces/ServerError.interface";
import { flattenObject } from "@/utils/object/flatten";
import { isEmptyObject } from "@/utils/object/isEmpty";

const { Text } = Typography;

/**
 * The `ErrorsComponent` component is responsible to display the errors got from the server.
 * @returns {JSX.Element} The rendered `ErrorsComponent` component.
 */
export const ErrorsComponent = ({ error }: { error: IRequestError }): JSX.Element => {
  const { t } = useTranslation();
  if (!error) {
    return <></>;
  }
  
  if (error?.description && (!error.meta || isEmptyObject(error.meta))) {
    return (
      <div className="mt-2">
        <Text type="danger">{error.description}</Text>
        <br/>
        <Text type="danger">{parse(t("error.generic_contact_us"))}</Text>
      </div>
    );
  } else if (error.meta) {
    const flattenErrorsObj = flattenObject(error.meta);
    // Display a list of error meta
    const metalist = Object.values(flattenErrorsObj).map((value, idx) => (
      <li key={idx}>
        <Text type="danger">{value}</Text>
      </li>
    ));

    return (
      <div className="mt-2">
        <ul className="errors-list">{metalist}</ul>
        <Text type="danger">{parse(t("error.generic_contact_us"))}</Text>
      </div>
    );
  }

  return <Text type="danger">{t("error.generic")}</Text>;
};
